import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { getCurrencySymbolByCode } from '@/common/helpers/helpers'
import {
  errorTypes,
  feeTypes,
} from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

import InfoFeeMessage from './InfoFeeMessage/InfoFeeMessage'
import * as Styles from './styles'

const ExtraFeeInput = ({
  onChangeBaseFee,
  onChangeExtraFee,
  onChangeIncludedItems,
  baseFee,
  extraFee,
  includedItems,
  currency = 'EUR',
  currencies = [],
  extraFeeType,
  isAdditionalExtraFeeActive,
  isAdditionalFee,
  disabled,
}) => {
  const { t } = useTranslation()
  const [error, setError] = useState('')
  const [extraFeeError, setExtraFeeError] = useState('')
  const currencySymbol = getCurrencySymbolByCode(currency, currencies)
  const includedItemsError = includedItems < 1 ? t('El mínimo es 1') : ''
  const includedItemsErrorId = isAdditionalFee
    ? errorTypes.invalidIncludedItemsAdditionalTransaction
    : errorTypes.invalidIncludedItems

  const handleChangeBaseFee = e => {
    onChangeBaseFee(e.target.value)
    if (e.target.value < 0 || e.target.value === '') {
      setError(t('El mínimo es 0'))
    } else {
      setError('')
    }
  }

  const handleChangeExtraFee = e => {
    onChangeExtraFee(e.target.value)
    if (e.target.value < 0 || e.target.value === '') {
      setExtraFeeError(t('El mínimo es 0'))
    } else {
      setExtraFeeError('')
    }
  }

  const handleChangeIncludedItems = e => onChangeIncludedItems(e.target.value)

  return (
    <Styles.MainContainer>
      {extraFeeType === feeTypes.flatFee && (
        <>
          <Styles.InputsContainer>
            <Styles.InputContainer>
              <InputWithLabel
                type="number"
                value={extraFee ? Number(extraFee) : extraFee}
                onChange={handleChangeExtraFee}
                label={t('Coste')}
                error={extraFeeError}
                fullWidth
                helperText={extraFeeError}
                startAdornment={currencySymbol}
                disabled={disabled}
              />
            </Styles.InputContainer>
          </Styles.InputsContainer>
          <InfoFeeMessage
            extraFeeType={extraFeeType}
            baseFee={baseFee}
            extraFee={extraFee}
            includedItems={includedItems}
            currency={currency}
            isAdditionalExtraFeeActive={isAdditionalExtraFeeActive}
            isAdditionalFee={isAdditionalFee}
          />
        </>
      )}

      {extraFeeType === feeTypes.perReturnedItem && (
        <>
          <Styles.InputsContainer>
            <Styles.InputContainer>
              <InputWithLabel
                type="number"
                value={baseFee ? Number(baseFee) : baseFee}
                onChange={handleChangeBaseFee}
                label={t('Coste base')}
                error={error}
                fullWidth
                helperText={error}
                startAdornment={currencySymbol}
                disabled={disabled}
              />
            </Styles.InputContainer>
            <Styles.InputContainer id={includedItemsErrorId}>
              <InputWithLabel
                type="number"
                value={includedItems ? Number(includedItems) : includedItems}
                onChange={handleChangeIncludedItems}
                label={t('# productos incluidos')}
                error={includedItemsError}
                fullWidth
                helperText={includedItemsError}
                disabled={disabled}
              />
            </Styles.InputContainer>
          </Styles.InputsContainer>
          <>
            <Text type="bodyMRegular"></Text>
            <Styles.InputContainer>
              <InputWithLabel
                type="number"
                value={extraFee ? Number(extraFee) : extraFee}
                onChange={handleChangeExtraFee}
                label={t('Coste extra por productos adicionales')}
                error={extraFeeError}
                fullWidth
                helperText={extraFeeError}
                startAdornment={currencySymbol}
                disabled={disabled}
              />
            </Styles.InputContainer>
          </>
          <InfoFeeMessage
            extraFeeType={extraFeeType}
            baseFee={baseFee}
            extraFee={extraFee}
            includedItems={includedItems}
            currency={currency}
            isAdditionalExtraFeeActive={isAdditionalExtraFeeActive}
            isAdditionalFee={isAdditionalFee}
          />
        </>
      )}
    </Styles.MainContainer>
  )
}

export default ExtraFeeInput
